<template>
  <div id="eyejack-creator">
    <NavigationMobile @toggleNav="toggleNav" />
    <div class="content" :class="{ 'open-nav': showNav }">
      <!-- Shared header — rendered on every route (home + articles) -->
        <div class="nav-bar">
          <a href="/" @click.prevent="handleLogoClick"
            ><img loading="lazy" decoding="async"
              class="header-logo"
              src="./assets/logo-red@2x.png"
              alt="EyeJack"
          /></a>
          <p class="header-title">EyeJack Creator</p>
          <div class="nav-actions">
            <Navigation v-if="!mobileView" />
            <a v-if="!mobileView" href="/login" target="_top" class="nav-login-link">
              <button class="primary nav-login-button">Log in</button>
            </a>
            <div v-if="mobileView" id="navigation-icon">
              <!-- The three bars are purely decorative, so the button needs an
                   accessible name of its own. aria-expanded/aria-controls let
                   screen readers and AI agents know it opens #navigation-mobile. -->
              <button
                type="button"
                class="navbar-toggle"
                :aria-label="showNav ? 'Close menu' : 'Open menu'"
                :aria-expanded="showNav ? 'true' : 'false'"
                aria-controls="navigation-mobile"
                @click="showNav = !showNav"
              >
                <div aria-hidden="true"></div>
                <div aria-hidden="true"></div>
                <div aria-hidden="true"></div>
              </button>
            </div>
          </div>
        </div>

      <router-view />

      <!-- Shared footer — rendered on every route -->
      <div class="footer-container" id="footer">
        <div class="footer-wrapper">
          <div class="eyejack-app">
            <img loading="lazy" decoding="async"
              id="footer-logo"
              src="./assets/footer-logo-white.png"
              alt="EyeJack"
            />
          </div>
          <div class="footer-fields">
            <div class="fields">
              <p class="field-title">Creator</p>
              <ul id="">
                <li>
                  <a
                    target="_blank"
                    href="https://eyejackapp.com/pages/hot-tips"
                    >Hot Tips</a
                  >
                </li>
                <li>
                  <a
                    target="_blank"
                    href="https://eyejackapp.com/pages/ar-animations"
                    >AR Animations</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://eyejackapp.com/pages/panels"
                    >Panels Tutorial</a
                  >
                </li>
              </ul>
            </div>
            <div class="fields">
              <p class="field-title"><br /></p>
              <ul id="">
                <li>
                  <router-link to="/articles/">Articles</router-link>
                </li>
                <li>
                  <a target="_blank" href="https://eyejackapp.com/pages/murals"
                    >Capturing Murals</a
                  >
                </li>
                <li>
                  <a target="_blank" href="https://eyejackapp.com/pages/support"
                    >Support</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <p
            class="keyline-after-long"
            style="text-align: center; margin: 0 auto; width: 1240px"
          ></p>

          <div class="footer-end">
            <div class="social-links">
              <a target="_blank" href="https://discord.gg/yMDHjWdWe9" aria-label="Discord">
                <svg class="social-icon" viewBox="0 0 24 24" role="img" aria-hidden="true">
                  <path d="M20.32 4.37A19.79 19.79 0 0 0 15.4 2.8a.07.07 0 0 0-.07.04c-.21.37-.45.85-.62 1.23a18.4 18.4 0 0 0-5.42 0 12.39 12.39 0 0 0-.63-1.23.08.08 0 0 0-.07-.04 19.74 19.74 0 0 0-4.92 1.57.06.06 0 0 0-.03.03C.53 9.05-.32 13.57.11 18.03a.08.08 0 0 0 .03.05 19.9 19.9 0 0 0 6.03 3.04.08.08 0 0 0 .08-.03c.47-.64.89-1.33 1.25-2.05a.08.08 0 0 0-.04-.1 12.96 12.96 0 0 1-1.9-.9.08.08 0 0 1-.01-.13c.13-.1.26-.2.39-.31a.08.08 0 0 1 .08-.01c3.99 1.82 8.3 1.82 12.24 0a.08.08 0 0 1 .09.01c.12.11.25.21.39.31a.08.08 0 0 1-.01.13c-.61.36-1.24.66-1.9.9a.08.08 0 0 0-.04.1c.36.72.78 1.41 1.25 2.05a.08.08 0 0 0 .08.03 19.85 19.85 0 0 0 6.03-3.04.08.08 0 0 0 .03-.05c.5-5.16-.84-9.64-3.53-13.66a.06.06 0 0 0-.03-.03zM8.02 15.3c-1.2 0-2.18-1.1-2.18-2.46s.97-2.46 2.18-2.46c1.22 0 2.2 1.11 2.18 2.46 0 1.36-.97 2.46-2.18 2.46zm7.96 0c-1.2 0-2.18-1.1-2.18-2.46s.97-2.46 2.18-2.46c1.22 0 2.2 1.11 2.18 2.46 0 1.36-.96 2.46-2.18 2.46z"/>
                </svg>
              </a>
              <a target="_blank" href="https://www.linkedin.com/company/eyejack/" aria-label="LinkedIn">
                <svg class="social-icon" viewBox="0 0 24 24" role="img" aria-hidden="true">
                  <path d="M20.45 20.45h-3.56v-5.58c0-1.33-.03-3.04-1.85-3.04-1.86 0-2.14 1.45-2.14 2.95v5.67H9.34V9h3.42v1.56h.05c.48-.9 1.64-1.85 3.37-1.85 3.61 0 4.27 2.38 4.27 5.48v6.26zM5.34 7.43a2.07 2.07 0 1 1 0-4.14 2.07 2.07 0 0 1 0 4.14zM7.12 20.45H3.56V9h3.56v11.45zM22.22 0H1.78C.8 0 0 .77 0 1.72v20.56C0 23.23.8 24 1.78 24h20.44c.98 0 1.78-.77 1.78-1.72V1.72C24 .77 23.2 0 22.22 0z"/>
                </svg>
              </a>
              <a target="_blank" href="mailto:info@eyejackapp.com">
                <img loading="lazy" decoding="async" id="mail-link" src="./assets/mail-white.png" alt="Email" />
              </a>
            </div>
            <div class="footer-copy">
              <p>
                © 2026 EyeJack. All rights reserved.
                <a
                  target="_blank"
                  id="terms"
                  href="https://eyejack.io/terms"
                  >Terms</a
                >
                <a
                  target="_blank"
                  id="privacy"
                  href="https://eyejack.io/privacy"
                  >Privacy</a
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// App shell. Holds the shared header + footer (so every route renders them from
// one source) and the mobile-nav state. Route content renders in <router-view />.
import Navigation from './components/Navigation'
import NavigationMobile from './components/NavigationMobile'

export default {
  name: 'eyejack-creator',
  components: {
    Navigation,
    NavigationMobile
  },
  data () {
    return {
      mobileView: true,
      showNav: false
    }
  },
  methods: {
    handleLogoClick () {
      this.showNav = false
      if (this.$route.path !== '/') {
        this.$router.push('/')
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    toggleNav () {
      this.showNav = !this.showNav
    },
    handleView () {
      this.mobileView = window.innerWidth <= 1091
    }
  },
  created () {
    this.handleView()
    window.addEventListener('resize', this.handleView)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleView)
  }
}
</script>
